import { useEffect } from "react"

import { FULLSTORY_ORG_ID } from "@/constants/fullstory"
import { useCurrentUserQuery } from "@/v2/graphql/public-generated-rq"
import * as FullStorySDK from "@fullstory/browser"

export default function FullStory() {
  const { data } = useCurrentUserQuery()

  useEffect(() => {
    if (!FullStorySDK.isInitialized()) {
      FullStorySDK.init({ orgId: FULLSTORY_ORG_ID })
    }
  }, [])

  useEffect(() => {
    if (data?.currentUser?.pid) {
      FullStorySDK.identify(data.currentUser.pid, {
        displayName: data.currentUser.name ?? undefined,
        email: data.currentUser.email ?? undefined,
      })
    }
  }, [data])

  return null
}
